import { render } from "./TenantDashboard.vue?vue&type=template&id=b38f287a&scoped=true"
import script from "./TenantDashboard.vue?vue&type=script&lang=js"
export * from "./TenantDashboard.vue?vue&type=script&lang=js"

import "./TenantDashboard.vue?vue&type=style&index=0&id=b38f287a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38f287a"]])

export default __exports__